import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=5b07f37d&"
import script from "./EditAddressModal.vue?vue&type=script&lang=ts&"
export * from "./EditAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b07f37d')) {
      api.createRecord('5b07f37d', component.options)
    } else {
      api.reload('5b07f37d', component.options)
    }
    module.hot.accept("./EditAddressModal.vue?vue&type=template&id=5b07f37d&", function () {
      api.rerender('5b07f37d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/address/EditAddressModal.vue"
export default component.exports